import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICES } from '../constants';

function Services() {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="hero" style={{ padding: '150px 2rem 80px' }}>
        <h1>Our Services</h1>
        <p>Comprehensive IT solutions tailored for growing businesses</p>
      </section>

      {/* Services Section */}
      <section>
        <div className="container">
          {SERVICES.map((service, index) => (
            <div key={service.id} style={{ marginBottom: '5rem' }}>
              <div className="grid grid-2" style={{ alignItems: 'center', gap: '4rem' }}>
                <div style={{ order: index % 2 === 1 ? 2 : 'initial' }}>
                  <span style={{ fontSize: '5rem', display: 'block', marginBottom: '1rem' }}>
                    {service.icon}
                  </span>
                  <h2>{service.title}</h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: '1.5rem' }}>
                    {service.description}
                  </p>
                  <Link to="/contact" className="btn">Get Started</Link>
                </div>
                <div style={{ order: index % 2 === 1 ? 1 : 'initial' }}>
                  <div className="card">
                    <h4 style={{ marginBottom: '1.5rem' }}>What You Get:</h4>
                    <ul style={{ marginTop: 0 }}>
                      {service.deliverables.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose Us */}
      <section style={{ backgroundColor: 'var(--bg-light)' }}>
        <div className="container">
          <div className="section-header">
            <h2>Why Work With Us?</h2>
            <p>What makes TopFluxe different</p>
          </div>
          <div className="grid grid-3">
            <div className="card">
              <span className="card-icon">⚡</span>
              <h3>Fast Execution</h3>
              <p>We move quickly without sacrificing quality. Most projects start within 1-2 weeks.</p>
            </div>
            <div className="card">
              <span className="card-icon">💰</span>
              <h3>Transparent Pricing</h3>
              <p>No hidden fees. Clear proposals with detailed breakdowns before we start.</p>
            </div>
            <div className="card">
              <span className="card-icon">🎯</span>
              <h3>Business-First Approach</h3>
              <p>We focus on outcomes that matter to your business, not just fancy tech.</p>
            </div>
            <div className="card">
              <span className="card-icon">🤝</span>
              <h3>Long-Term Partnership</h3>
              <p>We stick around. Many clients work with us for years as their trusted tech partner.</p>
            </div>
            <div className="card">
              <span className="card-icon">🔒</span>
              <h3>Security First</h3>
              <p>Security isn't an afterthought. We build it into everything we do from day one.</p>
            </div>
            <div className="card">
              <span className="card-icon">📞</span>
              <h3>Responsive Support</h3>
              <p>When you need us, we're there. Typical response time is under 4 hours.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ background: 'var(--primary-color)', color: 'white', textAlign: 'center' }}>
        <div className="container">
          <h2 style={{ color: 'white' }}>Let's Discuss Your Project</h2>
          <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '1.2rem', marginBottom: '2rem' }}>
            Book a free 30-minute consultation. No sales pitch, just honest advice.
          </p>
          <Link to="/contact" className="btn" style={{ backgroundColor: 'white', color: 'var(--primary-color)' }}>
            Schedule a Call
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Services;